import { REQUEST_METHOD } from '@/constants';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { apiInstance } from '@/utils';

export type MarketIntelConfigPayload = {
  focus_description?: string;
  focus_tags?: string[];
};

type MarketIntelConfigResponse = {
  vendor_id: number;
  has_config: boolean;
  updated_at: string | null;
  market_intel_config: {
    focus_description: string;
    focus_tags: string[];
  };
};

export const getMarketIntelConfig = async (): Promise<MarketIntelConfigResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: API_ENDPOINTS.marketIntelConfig,
  });

  return result.data;
};

export const saveMarketIntelConfig = async (
  data: MarketIntelConfigPayload,
): Promise<MarketIntelConfigResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.PUT,
    url: API_ENDPOINTS.marketIntelConfig,
    data,
  });

  return result.data;
};
